export const taskSubtaskTypeOptionConstant = [
    { name: "Issue", value: "Issue" },
    { name: "Bug", value: "Bug" },
    { name: "General", value: "General" },
    
  ];